export default __webpack_public_path__ + "static/media/Archer-Nicholson.d12465d2.pdf";